define([
    "jquery",
    "underscore",
    "marionette",
    "forms/login/login_form",
    "forms/login/create_user_form",
    "forms/login/forgot_password_form",
    "behaviors/form_errors_behavior",
    "models/login/password_model",
    "backbone.syphon",
    "bootstrap",
    "holdon"
], function ($, _, Marionette, LoginForm, CreateUserForm, ForgotPasswordForm, FormErrorsBehavior, Password) {
    const validation = Array.from({ length: 4 }).fill(false);

    return Marionette.View.extend({
        el: '#login_container',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'forgotPassword': '#forgot_password',
            'forgetFormSubmit': '#forget_form_submit',
            'mt4AccountNo': '#mt4_account_no',
            'email': '#email',
            'resetPasswordBtn': '#reset_password_btn',
            'mt4AccountNoDiv': '#mt4_account_no_div',
            'warningBox': '.warning_box',
            'warningMsg': '.warning_box span',
            'successBox': '.success_box',
            'errorBox': '.error_box',
            'errorMsg': '.error_box span',

            'noticeEmailLogin': '#notice_email_login',
            'noticeEmailLoginContent': '#notice_email_login_content',

            'formLogin': '#form_login',
            'loginSubmit': '#form_submit',
            'login': '#login',
            'loginDiv': '#login-btn-div',
            'password': '#form_login #password',

            'passwordInput': '#new_password',
            'confirmPasswordInput': '#confirm_password',

            'eyeBtn': '.show_password_btn_img',
            'clearBtn': '.clear_password_btn_img',

            'formCreateUser': '#form_create_user',
            'createUserId': '#create-user-id',
            'code': '#code',
            'changeEmailLogin': '#change_email_login',
            'changeEmailLoginFooter': '#change_email_login_footer',
            'changeEmailLoginCancel': '#change_email_login_cancel',
            'changeEmailLoginConfirm': '#change_email_login_confirm',
        },

        events: {
            'hidden.bs.modal @ui.forgotPassword': 'closeForgotPassword',
            'click @ui.loginSubmit': 'loginSubmit',
            'click @ui.resetPasswordBtn': 'resetPassword',
            'input @ui.passwordInput': 'changePasswordInput',
            'input @ui.confirmPasswordInput': 'changeConfirmPasswordInput',
            'click @ui.eyeBtn': 'triggerEyeBtn',
            'click @ui.clearBtn': 'triggerClearBtn',
            'keyup @ui.login': 'triggerSubmitActiveClass',
            'change @ui.login': 'triggerSubmitActiveClass',
            'keyup @ui.password': 'triggerSubmitActiveClass',
            'change @ui.password': 'triggerSubmitActiveClass',
            'click @ui.changeEmailLoginConfirm': 'createUserSubmit',
            'click @ui.changeEmailLoginCancel': 'cancelCreateUser',
        },

        initialize: function () {
        },

        closeForgotPassword: function(e) {
            this.triggerMethod('hide:errors');
            $(this.ui.successBox).hide();
            $(this.ui.errorBox).hide();
            $(this.ui.warningBox).addClass('hidden');
            $(this.ui.mt4AccountNoDiv).addClass('hidden');
            $(this.ui.errorMsg).html('');
            $(this.ui.email).val('')
        },

        loginSubmit: function (e) {
            e.preventDefault();

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            const formData = Backbone.Syphon.serialize(this.ui.formLogin);
            const form = new LoginForm();
            form.set(formData);

            const errors = form.validate();

            const that = this;
            if (_.size(errors) < 1) {
                $.ajax('/rest_login/login', {
                    method: "POST",
                    data: {
                        'login': formData.login,
                        'password': formData.password,
                        'remember_me': formData.remember_me,
                    },
                    success: function (data) {
                        that.triggerMethod('hide:errors');
                        if (data.open_create_user_modal === true) {
                            $(that.ui.createUserId).html(data.email);
                            $(that.ui.code).val(data.code);
                            if (data.show_limit_date === true) {
                                $(that.ui.changeEmailLoginFooter).html(data.limit_date);
                            } else {
                                $(that.ui.changeEmailLoginCancel).prop('disabled', true);
                            }
                            $(that.ui.changeEmailLogin).modal({backdrop: 'static', keyboard: false}, 'show');
                            HoldOn.close();
                        } else {
                            window.location = window.location.href;
                        }
                    },
                    error: function (xhr, textStatus, errorThrown) {
                        const error = xhr.responseJSON;
                        if (typeof error.form_error_msg !== 'undefined') {
                            that.triggerMethod('show:errors', error.form_error_msg);
                        } else {
                            $(that.ui.noticeEmailLoginContent).html(error.error_msg);
                            $(that.ui.noticeEmailLogin).modal('show');
                        }

                        HoldOn.close();
                    }
                })
            } else {
                this.triggerMethod('show:errors', errors);
                HoldOn.close();
            }
        },

        resetPassword: function (e) {
            e.preventDefault();

            this.triggerMethod('hide:errors');
            $(this.ui.successBox).hide();
            $(this.ui.errorBox).hide();
            $(this.ui.warningBox).addClass('hidden');
            $(this.ui.errorMsg).html('');

            const formData = Backbone.Syphon.serialize(this.$('#forget_form_submit')[0]);
            const form = new ForgotPasswordForm();
            form.set(formData);

            const errors = form.validate();

            const that = this;
            if (_.size(errors) < 1) {
                HoldOn.open({
                    theme: "sk-fading-circle"
                });

                $.ajax('/rest_login/password', {
                    method: "PUT",
                    data: {
                        'mt4_account_no': formData.mt4_account_no,
                        'email': formData.email,
                    },
                    success: function (data) {
                        that.triggerMethod('hide:errors');
                        $(that.ui.warningBox).addClass('hidden');
                        that.triggerMethod('show:success');
                    },
                    error: function (xhr, textStatus, errorThrown) {
                        let msg;
                        if (typeof xhr.responseJSON === 'undefined'
                            || typeof xhr.responseJSON.msg === 'undefined')
                            msg = 'Unknown Error';
                        else
                            msg = xhr.responseJSON.msg;

                        if (xhr.status === 400 && msg === 'undefined') {
                            that.triggerMethod('show:errors', xhr.responseJSON.errors);
                        } else if (xhr.status === 404) {
                            $(that.ui.mt4AccountNoDiv).removeClass('hidden');
                            $(that.ui.warningBox).removeClass('hidden');
                            $(that.ui.errorBox).hide();
                            $(that.ui.warningMsg).html(msg);
                        } else {
                            $(that.ui.errorBox).show();
                            $(that.ui.warningBox).addClass('hidden');
                            $(that.ui.errorMsg).html(msg);
                        }
                    },
                    then: function (model, response) {
                        $(that.ui.mt4AccountNoDiv).addClass('hidden');
                    }
                }).always(function () {
                    HoldOn.close();
                });
            } else {
                this.triggerMethod('show:errors', errors);
            }
        },

        createUserSubmit: function (e) {
            e.preventDefault();

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            const formData = Backbone.Syphon.serialize(this.ui.formCreateUser);
            const form = new CreateUserForm();
            form.set(formData);

            const errors = form.validate();

            const that = this;
            if (_.size(errors) < 1) {
                $.ajax('/rest_login/create_user', {
                    method: "POST",
                    data: {
                        'password': formData.new_password,
                        'confirm_password': formData.confirm_password,
                        'code': formData.code,
                    },
                    success: function (data) {
                        that.triggerMethod('hide:errors');
                        window.location = window.location.href;
                    },
                    error: function (xhr, textStatus, errorThrown) {
                        const error = xhr.responseJSON;
                        if (typeof error.form_error_msg !== 'undefined') {
                            that.triggerMethod('show:errors', error.form_error_msg);
                        } else {
                            $(that.ui.noticeEmailLoginContent).html(error.error_msg);
                            $(that.ui.noticeEmailLogin).modal('show');
                        }

                        HoldOn.close();
                    }
                })
            } else {
                this.triggerMethod('show:errors', errors);
                HoldOn.close();
            }
        },

        cancelCreateUser: function (e) {
            e.preventDefault();

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            window.location = window.location.href;
        },

        changePasswordInput: function(e) {
          const form = $(e.currentTarget).parent();
          const clearBtn = form.find('.clear_password_btn_img');

          if ($(e.currentTarget).val().length > 0) {
            form.addClass('active');
            clearBtn.show();
          } else {
            form.removeClass('active');
            clearBtn.hide();
          }

          const value = $(e.currentTarget).val();
          const validationBlock = $(document).find('.validation-block').first();

          if (value === '') {
            validationBlock.hide();
          } else {
            validationBlock.show();
          }

          // 영문 대문자/소문자 포함
          const uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;
          if (uppercaseRule.test(value)) {
            validationBlock.find('span:nth-child(1)').addClass('active');
            validation[0] = true;
          } else {
            validationBlock.find('span:nth-child(1)').removeClass('active');
            validation[0] = false;
          }

          // 특수문자 하나 이상 포함
          const specialCharRule = /[!@#$%^*+=-]+/;
          if (specialCharRule.test(value)) {
            validationBlock.find('span:nth-child(2)').addClass('active');
            validation[1] = true;
          } else {
            validationBlock.find('span:nth-child(2)').removeClass('active');
            validation[1] = false;
          }

          // 글자수 8자 이상, 15자 이하
          const lengthRule = /^.{8,15}$/;
          if (lengthRule.test(value)) {
            validationBlock.find('span:nth-child(3)').addClass('active');
            validation[2] = true;
          } else {
            validationBlock.find('span:nth-child(3)').removeClass('active');
            validation[2] = false;
          }

          // 숫자 하나 이상 포함
          const digitRule = /\d/;
          if (digitRule.test(value)) {
            validationBlock.find('span:nth-child(4)').addClass('active');
            validation[3] = true;
          } else {
            validationBlock.find('span:nth-child(4)').removeClass('active');
            validation[3] = false;
          }
        },

        changeConfirmPasswordInput: function(e) {
          const form = $(e.currentTarget).parent();
          const clearBtn = form.find('.clear_password_btn_img');

          if ($(e.currentTarget).val().length > 0) {
            form.addClass('active');
            clearBtn.show();
          } else {
            form.removeClass('active');
            clearBtn.hide();
          }

          const value = $(e.currentTarget).val();
          const validationBlock = $(document).find('.validation-block').last();

          if (value === '') {
            validationBlock.hide();
          } else {
            validationBlock.show();
          }

          if ($(document).find('#new_password').val() === value) {
            validationBlock.find('span').addClass('active');
            validationBlock.hide();

            if (validation.every(val => val === true)) {
              $(document).find('#change_email_login_confirm').removeAttr('disabled');
            }
          } else {
            validationBlock.find('span').removeClass('active');
            validationBlock.show();
            $(document).find('#change_email_login_confirm').attr('disabled', 'disabled');
          }
        },

        triggerEyeBtn: function (e) {
            const eyeBtn = $(e.currentTarget);
            const password = $(e.currentTarget).parent().parent().find('.password')
            const type = password.attr('type');
            if (type === 'text') {
                password.attr('type', 'password');
                eyeBtn.attr('src', '/assets/common/common/img/eye_icon_gray.svg');
            } else {
                password.attr('type', 'text');
                eyeBtn.attr('src', '/assets/common/common/img/hide_eye_gray.svg');
            }
        },

        triggerClearBtn: function (e) {
          const password = $(e.currentTarget).parent().parent().find('.password')

          password.val('');
          password.trigger('input');
          $(e.currentTarget).hide();
      },

        triggerSubmitActiveClass: function (e) {
            const login = $(this.ui.login);
            const password = $(this.ui.password);
            const loginSubmit = $(this.ui.loginDiv);
            if (login.val() !== '' && password.val() !== '') {
                loginSubmit.addClass('active');
            } else {
                loginSubmit.removeClass('active');
            }
        },
    });
});